import { motion } from "framer-motion";

// blur : la section sort d'un léger flou en apparaissant (utilisé sur l'accueil)
export default function Reveal({ children, delay = 0, className = "", y = 40, blur = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y, ...(blur && { filter: "blur(10px)" }) }}
      whileInView={{ opacity: 1, y: 0, ...(blur && { filter: "blur(0px)" }) }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
